export const listNotificationSubscriptions = `
   query listNotificationSubscriptions($region:String!, $topicArn:String, $limit: Int, $nextToken: String) {
       listSubscriptions(region:$region, topicArn: $topicArn, limit: $limit, nextToken: $nextToken) {
           items {
            subscriptionArn
            endpoint
            owner
            protocol
            topicArn
           }
           nextToken
       }
   }
`;

export const getNotificationSubscription = `
   query getNotificationSubscription($region:String!, $subscriptionArn:String!) {
       getSubscription(region:$region, subscriptionArn:$subscriptionArn) {
            subscriptionArn
            endpoint
            owner
            protocol
            topicArn
       } 
}`;
